window.Keepcon =
  Models: {}
  Collections: {}
  Views: {}
  Routers: {}
  init: () ->
    preferredFullLocales = navigator.languages || [navigator.language] || [navigator.userLanguage] # ['en-US', 'es-AR']
    preferredLocales = _.map(preferredFullLocales, (l) -> l.split('-')[0]) # ['en', 'es']
    bestLocale = _.find(preferredLocales, (l) -> _.contains(window.availableLocales, l)) || window.defaultLocale

    I18n.defaultLocale = window.defaultLocale
    I18n.locale = bestLocale

    moment.locale('es', {
      relativeTime : {
        future: "en %s",
        past:   "%s atras",
        s:  "segundos",
        m:  "un minuto",
        mm: "%d minutos",
        h:  "una hora",
        hh: "%d horas",
        d:  "un día",
        dd: "%d días",
        M:  "un mes",
        MM: "%d meses",
        y:  "un año",
        yy: "%d años"
      }
    });
    moment.locale(I18n.locale)
    Backbone.View.prototype.eventAggregator = _.extend({}, Backbone.Events)
    Backbone.View.prototype.partial = (template, args) ->
      return JST[template](args)
    JST.partial = (template, args) ->
      return this[template](args)
  addDefaultDataToRequests: ->
    Backbone._sync = Backbone.sync unless Backbone._sync
    account_id = Keepcon.currentAccount.id
    Backbone.sync = (method, model, options) ->
      options.headers ||= {}
      options.headers.account_id = account_id
      Backbone._sync(method, model, options)
    $.ajaxSetup
        beforeSend: (xhr) ->
          xhr.setRequestHeader('account_id', account_id)
          xhr.setRequestHeader('App-Versions', JSON.stringify(Keepcon.current_app_versions))
        complete: (xhr, status) =>
          @_checkApplicationVersion(xhr.getResponseHeader('Recommend-Reload'), xhr.getResponseHeader('Force-Reload'))
        error: (xhr) =>
          return if @_noLoginOrAccountErrors(xhr)
          if xhr.responseJSON['error'] == "AccountChanged"
            XhrControl.shutdown()
            swal({
              title: "#{I18n.t('self_service.account_checking.account_changed', {account_name: xhr.responseJSON['current_account_name']})}. #{I18n.t('self_service.account_checking.continue_with', {old_name: xhr.responseJSON['current_account_name'], new_name: xhr.responseJSON['last_account_name']})}",
              type: 'warning',
              showCancelButton: true,
              closeOnConfirm: true,
              cancelButtonText: I18n.t('self_service.account_checking.btn_continue', {account_name: xhr.responseJSON['current_account_name']}),
              confirmButtonText: I18n.t('self_service.account_checking.come_back', {account_name: xhr.responseJSON['last_account_name']}),
            }, (isConfirm) =>
              if isConfirm
                location.reload()
              else
                window.location['search'] = "?account_id=#{xhr.responseJSON['current_account_id']}"
            )
          else if xhr.responseJSON['error'] == "NewLoginDetected"
            XhrControl.shutdown()
            swal({
              title: xhr.responseJSON['message']
              type: "warning"
              closeOnConfirm: true
              confirmButtonText: "Ok"
            }, (isConfirm) => location.reload())

  addPublicAccessTokenToRequests: ->
    public_access_token = getUrlParam('public_access_token')
    $.ajaxSetup({ data: { public_access_token: public_access_token } }) if public_access_token

  # 'request canceled' is ignored || js errors ignored || no info sent from server
  _noLoginOrAccountErrors: (xhr) ->
    xhr.status == 0 && (xhr.statusText == 'abort' || xhr.statusText == 'error') || !xhr.responseJSON

  _checkApplicationVersion: (app_reload, global_reload) ->
    if (app_reload == 'true')
      @showAppReload()
      return
    if (global_reload == 'true')
      @showGlobalReload()
      return

  showAppReload: ->
    $(".reload-app").css("display","flex")
    $(".reload-app").animate({right:'20px'},500);

  showGlobalReload: ->
    XhrControl.shutdown()
    swal({
      title: "#{I18n.t('refresh_app.reload_line_1')}"
      text: "#{I18n.t('refresh_app.reload_line_2')}"
      type: 'warning'
      closeOnConfirm: true
      confirmButtonText: "#{I18n.t('refresh_app.button_text')}"
    }, (data) =>
      return if @reloading
      @reloading = true
      swal.closeModal()
      @reloadApp()
    )
    swal.closeModal = swal.close
    swal.close = () =>
      return if @reloading
      @reloading = true
      swal.closeModal()
      @reloadApp()

  reloadApp: ->
    $(".reload-app").animate({right:'-350px'}, 100);
    $("#wrap").fadeOut(100, () =>
      $("#wrap").html("<div class='reloading-app-background'>").show()
    )
    setTimeout () =>
      location.reload()
    , 200



window.Monitoring =
  Models: {}
  Collections: {}
  Views: {}
  Routers: {}
  Methods: {}

# intervals in ms
window.Customer =
  Methods: {}
  refreshIntervals:
    operatorStatus:     45000
    filterCount:        25000
    defaultNewInteractions:    30000
    checkRefreshNeeded: 30000
    notifications:      30000
    memoryLogger:      120000 # Two minutes
    newInteractionsByType: {
      'whatsapp': 5000
    }
  memoryLoggingAccounts: [
    231,
    643,
    648,
    831,
    836
  ]
  filterCountSkips: [
    {threshold: 1000, skips: 5}
    {threshold: 100, skips: 2}
  ]
  summariesForceRefresh:
    default: 40

window.Profiling = {}

window.Charts = {}

window.Moderation = Routers: {}

window.AccountSettings = Routers: {}

window.Surveys =
  Views: {}


window.insertTextAtCursor = (myField, myValue) ->
  if myField.selectionStart or myField.selectionStart is "0" or myField.selectionStart is 0
    startPos = myField.selectionStart
    endPos = myField.selectionEnd
    myField.value = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
    myField.selectionStart = startPos + myValue.length
    myField.selectionEnd = startPos + myValue.length
  else
    myField.value += myValue #IE support
  $(myField).trigger('input')
  return

window.getUrlParam = (name) ->
  decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null

# mixins !

window.extend = (obj, mixin) ->
  obj[name] = method for name, method of mixin
  obj
window.include = (klass, mixin) ->
  extend klass.prototype, mixin
window.merge = extend

# Remove broken images before running html2canvas (because they break its output)
(->
  _html2canvas = window.html2canvas
  window.html2canvas = ->
    $(arguments[0]).find('img').each ->
      image = $(this)
      if image.context.naturalWidth == 0 || image.readyState == 'uninitialized'
        $(image).remove()
    _html2canvas.apply(this, arguments)
)()

Number.prototype.toHHMMSS = ->
  hours = Math.floor(this / 3600)
  minutes = Math.floor((this - (hours * 3600)) / 60)
  seconds = this - (hours * 3600) - (minutes * 60)

  hours = "0#{hours}" if hours < 10
  minutes = "0#{minutes}" if minutes < 10
  seconds = "0#{seconds}" if seconds < 10

  "#{hours}:#{minutes}:#{('0' + Math.round(seconds)).slice(-2)}"


Date.prototype.getUTCOffset = ({withColon}) ->
  pad = (value) -> if value < 10 then '0' + value else value
  offset = @getTimezoneOffset()
  abs_offset = Math.abs offset
  sign = if offset > 0 then '-' else '+'
  hours = pad(Math.floor(abs_offset / 60))
  minutes = pad(abs_offset % 60)
  "#{sign}#{hours}#{if withColon then ':' else ''}#{minutes}"

# Add ability to zoom only when holding ctrl to leaflet
# ('scrollWheelZoom: true' overrides 'ctrlScrollWheelZoom: true')
_Lmap = Leaflet.map
Leaflet.map = (element, options) ->
  map = _Lmap element, options
  return map if options.scrollWheelZoom
  return map unless options.ctrlScrollWheelZoom
  map.scrollWheelZoom.disable()
  $(element).on 'mousewheel DOMMouseScroll', (event) =>
    event.stopPropagation()
    return unless event.ctrlKey
    event.preventDefault()
    isScrollUp = event.originalEvent.wheelDelta >= 0
    offset = $(element).offset()
    containerPoint = [event.pageX - offset.left, event.pageY - offset.top]
    zoomDelta = options.zoomDelta or 1
    zoomLevel = map.getZoom() + if isScrollUp then zoomDelta else -zoomDelta
    map.setZoomAround(
      map.containerPointToLatLng(containerPoint),
      zoomLevel
    ) if zoomLevel > 1
  map
